export const LocalStorageActionTypes = {
	GET_LOCAL_STORAGE_ITEM: '@@localStorage/GET_LOCAL_STORAGE_ITEM',
	SET_LOCAL_STORAGE_ITEM: '@@localStorage/SET_LOCAL_STORAGE_ITEM',
	REMOVE_LOCAL_STORAGE_ITEM: '@@localStorage/REMOVE_LOCAL_STORAGE_ITEM',
	LOCAL_STORAGE_ITEM_RECEIVED: '@@localStorage/LOCAL_STORAGE_ITEM_RECEIVED',
	LOCAL_STORAGE_ITEM_ERROR: '@@localStorage/LOCAL_STORAGE_ITEM_ERROR',
};